const DEFAULT_RELOAD_GUARD_MSG =
  "You have unsaved changes on this form. Reloading will discard them. Continue?";

/**
 * Persist only the given fields when the form supports partial saves.
 * Falls back to updateAndSave for forms without savePartialFields.
 */
export async function saveFormFields(form, updates) {
  if (!form || !updates || !Object.keys(updates).length) return;
  const recordId = form.values?._id;
  if (recordId && typeof form.savePartialFields === "function") {
    return form.savePartialFields(updates);
  }
  return form.updateAndSave(updates);
}

/**
 * Reload form from server after optional confirm when the user has unsaved edits.
 * Returns true when reload ran, false when cancelled or reload unavailable.
 */
export async function reloadFormWithGuard(
  form,
  message = DEFAULT_RELOAD_GUARD_MSG,
) {
  if (!form?.reload) return false;
  if (form.hasUnsavedUserChanges?.() && !window.confirm(message)) {
    return false;
  }
  await form.reload();
  return true;
}
